<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center" class="text-center mb-16 pb-16">
      <v-col cols="12">
        <span class="text-h6">{{ $t("Page403") }}</span>
        <v-img :src="require('../assets/' + $t('$assets.logo'))" class="my-3" contain height="200" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  created() {
    this.$store.commit("searchDistrict", false);
  },
};
</script>
